import type {
    ComposableOptionsBase
} from '~/types';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { NitroFetchOptions } from 'nitropack';
import type { NuxtError } from '#app';
import type { Customer } from '~/types';

export interface UseCustomerOptions extends ComposableOptionsBase {}
export function useCustomer(options: Partial<UseCustomerOptions> = {}) {
    const apiPaymentIntentsPath = '/v1/customer';
    // const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getCustomer(): Promise<Customer> {
        const url = `${apiPaymentIntentsPath}/`;

        const config: NitroFetchOptions<string> = {
            method: 'GET'
        };

        return await $_fetch<Customer>(url, config);
    }

    async function setAutopay(
        enable: boolean = true,
        payment_method_id?: string
    ): Promise<Customer> {
        const state = enable ? 'enable' : 'disable';
        const url = `${apiPaymentIntentsPath}/${state}-autopay/`;

        const config: NitroFetchOptions<string> = {
            method: 'POST'
        };

        if (payment_method_id) {
            config.body = {
                payment_method_id
            };
        }

        return await $_fetch<Customer>(url, config);
    }

    return {
        getCustomer,
        setAutopay
    };
}
